<button
  [ngClass]="iconPosition === 'inline-block' ? 'info-tooltip--inline-block' : ''"
  class="info-tooltip"
  [class.info-tooltip--circle]="variant === 'circle'"
  [attr.aria-label]="variant === 'circle' ? ('app.infoTooltip.ariaLabel' | transloco) : null"
  tooltipClass="custom-tooltip"
  [appTooltip]="tooltipContent"
  (hidden)="handleTooltipVisibilityChange(false)"
  (shown)="handleTooltipVisibilityChange(true)"
>
  @if (variant === "circle") {
    <!-- "i" is the icon glyph, not copy; the button's accessible name comes from aria-label. -->
    <span aria-hidden="true">i</span>
  } @else if (isTooltipVisible) {
    <app-svg-icon [icon]="'assets/images/icon-info-active.svg'" [blank]="true" />
  } @else if ((isLightTheme$ | async) === false) {
    <app-svg-icon [icon]="'assets/images/icon-info-v2.svg'" [blank]="true" />
  } @else {
    <app-svg-icon [icon]="'assets/images/icon-info-v2-light.svg'" [blank]="true" />
  }
</button>

<ng-template #tooltipContent>
  <ng-content></ng-content>
</ng-template>
